/* Gifted Theme — minimal vanilla JS */

document.addEventListener('DOMContentLoaded', () => {

  // Mobile menu toggle
  const menuBtn = document.querySelector('[data-menu-toggle]');
  const mobileMenu = document.querySelector('[data-mobile-menu]');
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', () => {
      const isOpen = mobileMenu.getAttribute('data-open') === 'true';
      mobileMenu.setAttribute('data-open', !isOpen);
      menuBtn.setAttribute('aria-expanded', !isOpen);
    });
  }

  // Variant option selector (visual feedback)
  document.querySelectorAll('.product__option').forEach(option => {
    const buttons = option.querySelectorAll('.product__option-value');
    buttons.forEach(btn => {
      btn.addEventListener('click', () => {
        buttons.forEach(b => b.setAttribute('aria-pressed', 'false'));
        btn.setAttribute('aria-pressed', 'true');
      });
    });
    if (buttons.length > 0) buttons[0].setAttribute('aria-pressed', 'true');
  });

  // Reveal-on-scroll for product cards
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.product-card').forEach((card, i) => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = `opacity 600ms cubic-bezier(0.4,0,0.2,1) ${i * 60}ms, transform 600ms cubic-bezier(0.4,0,0.2,1) ${i * 60}ms, box-shadow 280ms`;
      io.observe(card);
    });
  }
});
